import React, { Component } from 'react';
import Loading from '../Loading/Loading';
import Geral from '../../Utils/Geral';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import update from 'immutability-helper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;

class ShippingSummary extends Component {
    constructor(props) {
        super(props);
        this.gerarArquivo = this.gerarArquivo.bind(this);
        this.gerarEtiquetas = this.gerarEtiquetas.bind(this);
        this.handleError = this.handleError.bind(this);
        this.toggleModalArquivoSucesso = this.toggleModalArquivoSucesso.bind(this);
        this.enviarArquivo = this.enviarArquivo.bind(this);
        this.downloadArquivo = this.downloadArquivo.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            isLoadingGerarEtiquetas: false,
            isOpenModalArquivoSucesso: false,
            remessa: [],
            isLoadingEnviar: false,
            hasError: "",
        }
    }

    handleError(err) {
        this.setState({
            hasError: true, errorMessage: err.response ? err.response.data.msg || err.response.data.message : !!err.message ? err.message : 'Erro inesperado.'
        })
    }

    gerarArquivo() {
        this.setState({ isLoadingGerarArquivo: true })
        axios.post(this.Configurations.apiBasePath + `/logistica/remessa/${this.props.idRemessa}/assinantes/gerar-arquivo`)
            .then(response => {
                this.setState({
                    remessa: response.data.data,
                })
                this.toggleModalArquivoSucesso();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingGerarArquivo: false }))

    }

    gerarEtiquetas() {
        this.setState({ isLoadingGerarEtiquetas: true })
        axios.get(this.Configurations.apiBasePath + `/logistica/remessa/${this.props.idRemessa}/gerar-etiquetas`)
            .then(response => {
                const docDefinition = response.data.data;
                pdfMake.createPdf(docDefinition).open();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingGerarEtiquetas: false }))
    }
    toggleModalArquivoSucesso() {
        this.setState({
            isOpenModalArquivoSucesso: !this.state.isOpenModalArquivoSucesso,
            mensagem: ''
        })
    }

    enviarArquivo(idTransportadora, indice) {
        const body = {
            arquivo: this.state.remessa[indice].arquivo,
            idTransportadora: this.state.remessa[indice].idTransportadora,
            edicaoRemessa: this.state.remessa[indice].edicaoRemessa
        }
        this.setState({
            remessa: update(this.state.remessa, { [indice]: { isLoadingEnviar: { $set: true }, arquivoEnviadoSucesso: { $set: false } } }),
            mensagem: ''
        });

        axios.post(this.Configurations.apiBasePath + `/logistica/remessa/${this.props.idRemessa}/assinantes/enviar-arquivo`, body)
            .then(response => {
                this.setState({
                    mensagem: response.data.message,
                    remessa: update(this.state.remessa, { [indice]: { arquivoEnviadoSucesso: { $set: true } } })
                })
            }).catch(this.handleError).finally(() => this.setState({
                remessa: update(this.state.remessa, { [indice]: { isLoadingEnviar: { $set: false } } }),
            }));

    }

    downloadArquivo(idTransportadora, indice) {
        const body = {
            arquivo: this.state.remessa[indice].arquivo,
            idTransportadora: this.state.remessa[indice].idTransportadora,
            edicaoRemessa: this.state.remessa[indice].edicaoRemessa
        }
        this.setState({ remessa: update(this.state.remessa, { [indice]: { isLoadingEnviar: { $set: true } } }) });
        axios.post(this.Configurations.apiBasePath + `/logistica/remessa/${this.props.idRemessa}/assinantes/enviar-arquivo`, body)
            .then(response => {
                const { data: { encodeFile } } = response;
                if (!!encodeFile && idTransportadora === 2) {
                    Geral.downloadFile(encodeFile, `arquivo-remessa`, "csv")
                    this.toggleModalArquivoSucesso();
                }
            }).catch(this.handleError).finally(() => this.setState({ remessa: update(this.state.remessa, { [indice]: { isLoadingEnviar: { $set: false } } }) }));
    }

    render() {
        return (

            <div className="card">
                <div className="card-header">
                    {this.props.shipping ? 'Resumo da remessa' : 'Inicie uma remessa'}
                </div>
                <div className="card-body">
                    <Loading show={this.props.isLoading} />

                    {!this.props.shipping ? (
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className='row'>
                                    <div className='col-6 text-right'>
                                        <button className="btn btn-success" disabled={this.props.isLoading} onClick={() => this.props.newShippingEvent()}>
                                            {this.props.isLoading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin mr-3"></i>
                                                    Criando nova remessa, aguarde
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-shipping-fast mr-3"></i>
                                                    Criar nova remessa
                                                </>
                                            )}
                                        </button>
                                    </div>
                                    <div className='col-6 text-left'>
                                        <button className="btn btn-primary" disabled={this.props.isLoading} onClick={() => this.props.setarFlagReenvio(true)}>
                                            {this.props.isLoading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin mr-3"></i>
                                                    Criando remessa reenvio, aguarde
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-shipping-fast mr-3"></i>
                                                    Criar remessa reenvio
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="row align-items-center">
                                <div className="col-6 col-lg-3 text-center border-right">
                                    <strong className="display-4 font-weight-bold">{this.props.shipping.id}</strong><br />
                                    <span>número da remessa</span>
                                </div>
                                <div className="col-6 col-lg-3 text-center border-right">
                                    <strong className="display-4 font-weight-bold">{this.props.shipping.items}</strong><br />
                                    <span>total de itens na remessa</span>
                                </div>
                                <div className="col-6 col-lg-3 text-center border-right">

                                    {this.props.shipping && this.props.shipping.editions.length === 0 && (
                                        <span>
                                            Nenhum item adicionado ainda.
                                        </span>
                                    )}
                                    {this.props.shipping.products.map((product, index) => {
                                        return (
                                            <span key={index} className={`log-badge badge badge-${Geral.badgeProductType(product.nome)} m-2`}>{product.nome}</span>
                                        )
                                    })}
                                    {this.props.shipping.products.length > 0 && (
                                        <>
                                            <br />
                                            <span>produtos na remessa</span>
                                        </>
                                    )}
                                </div>
                                <div className="col-6 col-lg-3 text-center">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Produto</th>
                                                <th>Edição</th>
                                                <th>Qtd</th>
                                            </tr>
                                            {this.props.shipping && this.props.shipping.editions.length === 0 && (
                                                <tr>
                                                    <td colSpan={3}>
                                                        Nenhum item adicionado ainda.
                                                    </td>
                                                </tr>
                                            )}
                                            {this.props.shipping && this.props.shipping.editions.map((edition, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td><strong>{edition.sigla}</strong></td>
                                                        <td>{edition.numeroEdicao}</td>
                                                        <td>{edition.qtd}</td>
                                                    </tr>
                                                )
                                            })}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div className="row align-items-end">
                                <div className="col-12 mt-4 pt-3 text-right border-top">
                                    {this.state.isLoadingGerarArquivo ? (
                                        <div className="spinner-border text-primary" />
                                    ) : (
                                        <button className="btn btn-info mr-2" onClick={this.gerarArquivo} disabled={this.props.shipping.totalItens <= 0}><i className="fas fa-file-csv mr-2"></i>GERAR ARQUIVO</button>
                                    )}
                                    {this.state.isLoadingGerarEtiquetas ? (
                                        <div className="spinner-border text-primary text-center px-2" role="status" />
                                    ) : (
                                        <button className="btn btn-success" onClick={this.gerarEtiquetas} disabled={this.props.shipping.totalItens <= 0}><i className="fas fa-file-import mr-2"></i>GERAR ETIQUETAS</button>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <Modal size="lg" className="modal-arquivo" isOpen={this.state.isOpenModalArquivoSucesso} toggle={this.toggleModalArquivoSucesso}>
                    <ModalHeader toggle={this.toggleModalArquivoSucesso}></ModalHeader>
                    <ModalBody>
                        <table className='tabela-remessa table w-100 text-center table-bordered'>
                            <thead>
                                <tr>
                                    <th width="20%">Produto</th>
                                    <th width="20%">Edição</th>
                                    <th width="25%">Arquivo</th>
                                    <th width="25%"></th>
                                    <th width="10%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.remessa.map((item, index) => {
                                    const enviarViaFTP = item.idTransportadora === 1;
                                    const labelBotao = enviarViaFTP ? 'Enviar para FTP' : "Download"
                                    return (
                                        < tr key={index} >
                                            <td width="20%" className='text-center'><span className={`badge badge-${Geral.badgeProductType(item.produto)} badge-periodico`}>{item.produto}</span></td>
                                            <td width="20%" className='text-center'>{item.edicaoRemessa}</td>
                                            <td width="25%" className='text-center'>{item.arquivo}</td>
                                            <td width="25%" className='text-center'>
                                                {item.isLoadingEnviar ? (
                                                    <div className="spinner-border  text-primary" role="status" />
                                                ) : (
                                                    <button className='btn btn-outline-success' onClick={enviarViaFTP ? () => this.enviarArquivo(item.idTransportadora, index) : () => this.downloadArquivo(item.idTransportadora, index)}>{labelBotao}</button>
                                                )}
                                            </td>
                                            {enviarViaFTP && (
                                                <td width="10%" className='text-center'>
                                                    {item.arquivoEnviadoSucesso && (
                                                        <i className='far fa-check-square fa-lg'></i>
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    )
                                }
                                )}
                            </tbody>
                        </table>
                        <div className='row py-3 '>
                            <div className='col-12 text-center text-danger'>
                                {this.state.hasError && (
                                    <span>Ocorreu um erro. Por favor, tente mais tarde.</span>
                                )}
                            </div>
                        </div>
                        <div className='row py-3 '>
                            <div className='col-12 text-center text-success'>
                                {!!this.state.mensagem && (
                                    <span>{this.state.mensagem}</span>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}


export default ShippingSummary;
